import "./check-box.scss";
import m from "mithril";
import svg from "../../../svg";

export default () => {
    let localchecked = false;
    return {
        view: v => {
            if ("checked" in v.attrs)
                localchecked = v.attrs.checked;
            let svgname = "";

            if (localchecked)
                svgname = "checkticked";
            else
                svgname = "checkblank";

            if (v.attrs.svgname)
                svgname = v.attrs.svgname;


            return m(".checkbox-wrapper", {
                style: `display: ${v.attrs.standard? "block":"inline-block"};`
            }, [
                m("label.prasora-checkbox", {
                    class: `${localchecked? "checked": "unchecked"} ${v.attrs.svgname? "icon-type":""} ${v.attrs.standard? "standard":"button-type"} ${v.attrs.textbefore?"text-before":"text-after"}`
                }, [
                    (!v.attrs.textbefore) && m(svg, {
                        name: svgname
                    }),
                    (v.attrs.textbefore && !!v.children.length) && m("span", v.children),
                    m("input", {
                        type: "checkbox",
                        onchange: e => {
                            localchecked = e.target.checked;
                            if (v.attrs.onchange)
                                v.attrs.onchange(e.target.checked);
                        },
                        checked: localchecked
                    }),
                    (!v.attrs.textbefore && !!v.children.length) && m("span", v.children),
                    (v.attrs.textbefore) && m(svg, {
                        name: svgname
                    }),
                ])
            ])
        }
    }
}